/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query PaymentReadQuery($paymentId: ID!) {
  PaymentRead(paymentId: $paymentId) {
    id,
    amount,
    message,
    status
  }
}
`
